export default __webpack_public_path__ + "static/media/goshen75.0450ff1d.jpg";